import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { PaginationInput } from '@/models/app';

export const fetchCustomerAddress = async ({
  callerId,
  pagination = { offset: 0, limit: 100 },
  isApproved,
}: {
  callerId: string;
  pagination?: PaginationInput;
  isApproved?: boolean;
}) => {
  const response = await queryExecute({
    query: graphql(`
      query CallerAddresses($callerId: String!, $pagination: PaginationInputType) {
        callerAddresses(callerId: $callerId, pagination: $pagination) {
          count
          rows {
            id
            name
            streetAddress
            streetAddress2
            city
            state
            zip
            country
            latitude
            longitude
            googlePlaceId
            order
            noteToDriver
            gourmetNoteToDriver
            coordinatesChanges
            phoneNumber
            createdAt
            isAirport
            isApproved
          }
        }
      }
    `),
    variables: {
      callerId,
      pagination,
      ...(isApproved !== undefined ? { isApproved } : {}),
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.callerAddresses;
};
